import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBQejsC9Uug7gYYcoFnjIR_fsx_2GyLDww",
  authDomain: "relation-stamp.firebaseapp.com",
  databaseURL: "https://relation-stamp-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "relation-stamp",
  storageBucket: "relation-stamp.firebasestorage.app",
  messagingSenderId: "229190086852",
  appId: "1:229190086852:web:470f790e018f97aed15991"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
